import styled, { keyframes } from 'styled-components';
import { Text } from '@hcsc-fiber/react';
import { useAEMContext } from '../../../store/aemStore';

interface ILoaderSpinner {
  message?: string;
  fontweight?: 'normal' | 'bold' | 'light';
  title?: string;
  titleFontWeight?: 'normal' | 'bold' | 'light';
}

const LoaderSpinner = ({
  message,
  fontweight = 'normal',
  title,
  titleFontWeight = 'bold',
}: ILoaderSpinner): JSX.Element | null => {
  const { AEMCommonContent } = useAEMContext();
  const {
    preloaderMessage: {
      label: { loadingLabel },
    },
  } = AEMCommonContent;

  return (
    <StyledWrapper>
      <SpinnerContainer>
        <Spinner data-testid="loading-spinner">
          <MaskCircle />
        </Spinner>
      </SpinnerContainer>
      {title && (
        <TitleWrapper>
          <Text
            fontStyle={'normal'}
            size={3}
            data-testid="loading-spinner-title"
            color="black"
            textAlign="center"
            fontWeight={titleFontWeight}
          >
            {title}
          </Text>
        </TitleWrapper>
      )}
      <Text
        fontStyle={'normal'}
        size={3}
        data-testid="loading-spinner-msg"
        color="black"
        margin={[4, 0, 0, 0]}
        textAlign="center"
        fontWeight={fontweight}
      >
        {message || loadingLabel}
      </Text>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0.9;
  background-color: ${(props) => props.theme.colorWhite};
  z-index: 3;
  span {
    max-width:16.875rem;
    word-wrap:break-word;
    word:break:break-all;
    text-align:center;
  }
`;

const TitleWrapper = styled.div`
  margin: 2%;
`;

const SpinnerContainer = styled.div`
  width: 4.75rem;
  height: 4.75rem;
`;

const rotationAnimation = keyframes`
  100% { transform: rotate(360deg) }
`;

const Spinner = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  border-radius: ${(props) => props.theme.borderRadiusCircle};
  // use conic if browser supports, otherwise fallback to linear
  background-image: linear-gradient(
    ${(props) => props.theme.colorBlueSecondary1} 0%,
    ${(props) => props.theme.colorBlueSecondary2} 15%,
    ${(props) => props.theme.colorBluePrimary} 50%,
    ${(props) => props.theme.colorBlueSecondary3} 100%
  );
  background-image: conic-gradient(
    ${(props) => props.theme.colorBlueSecondary1} 0%,
    ${(props) => props.theme.colorBlueSecondary2} 25%,
    ${(props) => props.theme.colorBluePrimary} 50%,
    ${(props) => props.theme.colorBlueSecondary3} 100%
  );
  animation-name: ${rotationAnimation};
  animation-duration: 1s;
  animation-iteration-count: infinite;
`;
const MaskCircle = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  position: absolute;
  left: 0.625rem;
  top: 0.625rem;
  background-color: ${(props) => props.theme.colorGray0};
  margin: 0 auto;
  border-radius: ${(props) => props.theme.borderRadiusCircle};
`;

export default LoaderSpinner;
